import Login from "../Pages/Authentication/Login";
import Home from "../Pages/Home";
import Services from "../Pages/Services";
import ProductRange from "../Pages/ProductRange";
import Events from "../Pages/Events";
import BinStock from "../Pages/BinStock";
import BinStockDetail from "../Pages/BinStock/BinStockDetail";
import Catalogs from "../Pages/Catalogs";
import AboutUs from "../Pages/AboutUs";
import ContactUs from "../Pages/ContactUs";
import Learn from "../Pages/Learn";
import BlogDetail from "../Pages/Learn/BlogDetail";
import Register from "../Pages/Authentication/Register"
import ForgetPassword from "../Pages/Authentication/ForgetPassword"
import TermsConditions from "../Pages/TermsConditions";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import AddToCart from "../Pages/AddToCart/AddToCart";
import UserProfile from "#pages/Authentication/user-profile.js";
import ChangePassword from "../Pages/Authentication/Changepassword"

// import Home from "../Pages/Home/index";
// import Services from "../Pages/Services";
// import AboutUs from "../Pages/AboutUs/index";


export const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/register", component: <Register /> },
  { path: "/forget-password", component: <ForgetPassword /> },
  { path: "/about-us", component: <AboutUs /> },
  { path: "/contact-us", component: <ContactUs /> },
  { path: "/product-range", component: <ProductRange /> },
  { path: "/catalogs", component: <Catalogs /> },
  { path: "/events", component: <Events /> },
  { path: "/services", component: <Services /> },
  { path: "/learn", component: <Learn /> },
  { path: "/bin-stock-detail/:productId", component: <BinStockDetail /> },
  { path: "/add-to-cart", component: <AddToCart /> },
  { path: "/learn/blog/:slug", component: <BlogDetail /> },
  { path: "/terms-condition", component: <TermsConditions /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/", component: <Home /> },
];


// export const authProtectedRoutes = [

export const authProtectedRoutes = [
    { path: "/bin-stock", component: <BinStock /> },
    { path: "/change-password", component: <ChangePassword /> },
    { path: "/user-profile", component: <UserProfile /> },

];

// export const authProtectedRoutes = [
// ];
